import moment from "moment";
import { PRIMARY } from "../governanceStatus";

/** Shared look for the governance detail pages (item + weekly report). */

export const TEXT = "#2c2c34";
export const MUTED = "#5a5a66";
export const FAINT = "#8a8a93";
export const AMBER_TEXT = "#8a6d00";

export const MONO = 'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

/** Today as "Oct 10, 2026" for success banners. */
export const todayLabel = () => moment().format("MMM D, YYYY");

/** Today as YYYY-MM-DD in the user's own day (date inputs). */
export const todayIso = () => moment().format("YYYY-MM-DD");

const actionBase = { minHeight: 44, textTransform: "none", fontWeight: 700 } as const;

/** Thrive-purple contained button (Post comment, Save result, Acknowledge). */
export const primaryButtonSx = {
  ...actionBase,
  backgroundColor: PRIMARY,
  "&:hover": { backgroundColor: "#7d184e" },
} as const;

/** Use with `variant="contained" color="success"`. */
export const approveButtonSx = actionBase;

/** Use with `variant="outlined" color="error"`. */
export const rejectButtonSx = actionBase;

/** Neutral outlined button (Defer, Reopen, Send back). */
export const neutralButtonSx = {
  ...actionBase,
  color: MUTED,
  borderColor: "#c9c9d1",
  "&:hover": { borderColor: MUTED, backgroundColor: "#f6f6f8" },
} as const;

/** Only http(s) evidence links are rendered as links. */
export const isSafeUrl = (url: string | null | undefined) => !!url && /^https?:\/\//i.test(url.trim());

/** A quoted comment (sign-off request, decision, acknowledgement). */
export const quoteSx = {
  mt: 0.75,
  pl: 1.5,
  borderLeft: "3px solid #e3e3e8",
  color: MUTED,
  whiteSpace: "pre-line",
  overflowWrap: "anywhere",
} as const;
